import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter as Router } from "react-router-dom";
import ThemeProvider from './ThemeContext';
import './Utilities/Translations/i18n'
import Loader from './Components/Common/Loader';
import { GoogleOAuthProvider } from '@react-oauth/google';
import ProfileDataProvider from './Components/HomePage/ProfileContext';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <Suspense fallback={<Loader />}>
    <ThemeProvider>
    {/* <ProfileDataProvider> */}

      <GoogleOAuthProvider clientId={process.env.REACT_APP_CLIENT_ID}>
        <Router>
          <App />
          
        </Router>
      </GoogleOAuthProvider>
      {/* </ProfileDataProvider> */}
    </ThemeProvider>
  </Suspense>
  // </React.StrictMode> 
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
